module.exports = __webpack_public_path__ + "img/IMG_6689_L_WoodMatted_MockedUp.ee8ae45c.jpg";